import { createApp } from 'vue';
import TgsToWebpConverter from '@/Components/TgsToWebpConverter.vue';
import '@styles/app.css';

createApp(TgsToWebpConverter).mount('#tgs-to-webp-converter');
